import { FC } from "react";
import { Button } from "@/components/ui/button";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/useStore";
import { DialogTitle, DialogDescription, DialogHeader, DialogFooter } from "@/components/ui/dialog";

interface ConfirmModalProps {
	title: string;
	description?: string;
	onConfirmCallback?: () => void;
	confirmButtonText?: string;
	onCancelCallback?: () => void;
	cancelButtonText?: string;
}

export const ConfirmModal: FC<ConfirmModalProps> = observer(
	({ title, description, onConfirmCallback, onCancelCallback = () => {} }) => {
		const {
			uiStore: { modalStore },
		} = useStore();

		const onCancelClick = () => {
			if (onCancelCallback) {
				modalStore.close();
				onCancelCallback();
			}
		};

		const onConfirmClick = () => {
			if (onConfirmCallback) {
				onConfirmCallback();
			}
		};
		return (
			<>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					{description && <DialogDescription>{description}</DialogDescription>}
				</DialogHeader>

				<DialogFooter>
					<Button variant="outline" onClick={onCancelClick}>
						Cancel
					</Button>
					{onConfirmCallback && <Button onClick={onConfirmClick}>OK</Button>}
				</DialogFooter>
			</>
		);
	},
);
